import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from '../../../services/authservices.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-jobs',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.css']
})
export class JobsComponent implements OnInit {

  loading = true;          
  jobList: any[] = [];
  selectedJob: any = null;

  constructor(
    private authService: AuthservicesService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.getJobPosts();
  }

  getJobPosts() {
    this.loading = true;

    this.authService.getJobPosts().subscribe(
      (res: any) => {
        console.log('Jobs Response:', res);
        this.jobList = res?.items || res?.data || [];
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.error('Error fetching jobs:', error);
        this.authService.successMessage(error?.error?.message || 'Failed to load jobs', 'error');
      }
    );
  }

  openDetailsModal(modal: any, job: any) {
    this.selectedJob = job;
    this.modalService.open(modal, { size: 'lg', centered: true });
  }
}